import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatTooltipModule } from "@angular/material/tooltip";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { SelectFileComponent } from "./select-file.component";

@NgModule({
  declarations: [SelectFileComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule.withConfig({ callSetDisabledState: "always" }),
    FontAwesomeModule,
    MatTooltipModule
  ],
  exports: [SelectFileComponent]
})
export class SelectFileModule {}
